function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import ReactDOM from "react-dom";
import { FlexRow, Input, Icon, Button, usePortal } from "../../";
export const LinkModal = /*#__PURE__*/React.forwardRef((props, ref) => (({
  currentLink,
  onComplete,
  onRemove,
  position,
  ...props
}) => {
  const [link, setLink] = useState(currentLink);
  const [error, setError] = useState(false);
  const inputRef = useRef();
  const portal = usePortal(true);

  const handleChange = val => {
    setError(false);
    setLink(val ? val.toLowerCase() : val);
  };

  const handleSubmit = () => {
    const protocallIsValid = link.startsWith("http://") || link.startsWith("https://");

    if (protocallIsValid) {
      onComplete(link);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    const inputElement = inputRef?.current;

    if (!!inputElement) {
      inputElement.focus();
    }
  }, []);
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkEditorContainer, _extends({
    position: position
  }, props), /*#__PURE__*/React.createElement(Input, {
    leftIcon: error ? /*#__PURE__*/React.createElement(Icon, {
      form: true,
      name: "Error"
    }) : /*#__PURE__*/React.createElement(Icon, {
      form: true,
      name: "Link"
    }),
    placeholder: "https://www.website.com",
    onChange: handleChange,
    value: link,
    error: error,
    ref: inputRef
  }), /*#__PURE__*/React.createElement(ActionContainer, null, /*#__PURE__*/React.createElement(FlexRow, null, /*#__PURE__*/React.createElement(ActionButton, {
    forMobile: true,
    type: "link",
    onClick: () => onComplete()
  }, "Cancel"), /*#__PURE__*/React.createElement(ActionButton, {
    type: "link",
    onClick: handleSubmit
  }, currentLink ? "Update" : "Apply")), currentLink && /*#__PURE__*/React.createElement(IconButton, {
    type: "link",
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Delete"
  })))), /*#__PURE__*/React.createElement(Backdrop, null)), portal);
})({ ...props,
  ref
}));
const LinkEditorContainer = styled(FlexRow)`
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.48);
  padding: 16px;
  position: absolute;
  top: ${props => props.position?.top}px;
  left: ${props => props.position?.left}px;
  z-index: 99999;
  input {
    width: 392px;
  }
  @media only screen and ${props => props.theme.media.small} {
    border-radius: 0;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.24), 0 1px 8px 0 rgba(0, 0, 0, 0.32);
    flex-direction: column;
    padding: 16px 20px;
    position: fixed;
    top: 20vh;
    left: 0;
    width: 100%;
    input {
      width: 100%;
    }
  }
`;
const ActionButton = styled(Button)`
  color: ${props => props.theme.palette.gray.primary};
  margin-left: 16px;
  min-width: 80px;
  &:not(:disabled):hover,
  &:not(:disabled):focus {
    background-color: #f5f5f5;
    color: #222222;
    text-decoration: none;
  }
  ${props => props.forMobile && `display: none`};
  @media only screen and ${props => props.theme.media.small} {
    display: flex;
    color: ${props => props.theme.palette.purple.primary};
    margin-top: 12px;
    margin-left: 0;
    & + & {
      margin-left: 16px;
    }
  }
`;
const IconButton = styled(ActionButton)`
  border-radius: 50%;
  color: ${props => props.theme.palette.gray.primary};
  margin-left: 16px;
  min-width: 40px;
  width: 40px;
  &:not(:disabled):hover,
  &:not(:disabled):focus {
    background-color: #f5f5f5;
    color: #222222;
    text-decoration: none;
  }
  @media only screen and ${props => props.theme.media.small} {
    align-self: flex-end;
  }
`;
const Backdrop = styled.div`
  background: rgba(0, 0, 0, 0.38);
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99998;
  @media only screen and ${props => props.theme.media.small} {
    display: block;
  }
`;
const ActionContainer = styled(FlexRow)`
  @media only screen and ${props => props.theme.media.small} {
    justify-content: space-between;
  }
`;